import {
  Dialog,
  DialogButtons,
  DialogContent,
  DialogMessageBox,
  DialogTitle,
} from '@verantos-dev/shared-components';

import type { VariableEditSaveDialogProps } from '../types';
import { DIALOG_PAPER_SX } from './dialogPaperSx';

// Blocks the variable list while a delete or reorder is saved. It has no exit
// until the save fails; the error state offers Retry or Dismiss.
export const VariableEditSaveDialog = ({
  isSaving,
  hasError,
  messages,
  onRetry,
  onDismiss,
}: VariableEditSaveDialogProps) => {
  if (!isSaving && !hasError) return null;
  const inError = hasError && !isSaving;

  return (
    <Dialog
      id="variableEditSaveDialog"
      open
      PaperProps={{ sx: DIALOG_PAPER_SX }}
      fullWidth
      maxWidth="lg"
      onClose={inError ? onDismiss : undefined}
    >
      <DialogTitle
        id="variable-edit-save-dialog-title"
        showClose={inError}
        onClose={inError ? onDismiss : undefined}
      >
        {inError ? messages.errorTitle : messages.savingTitle}
      </DialogTitle>
      <DialogContent>
        {inError ? (
          <DialogMessageBox
            id="variable-edit-save-dialog-error"
            title={messages.errorTitle}
            type="error"
            text={messages.errorText}
          />
        ) : (
          <DialogMessageBox
            id="variable-edit-save-dialog-loading"
            title={messages.savingTitle}
            type="loading"
            text={messages.savingText}
          />
        )}
      </DialogContent>
      {inError && (
        <DialogButtons
          id="variable-edit-save-dialog-buttons"
          cancelButton={{ label: messages.dismissLabel, onClick: onDismiss }}
          saveButton={{ label: messages.retryLabel, onClick: onRetry }}
        />
      )}
    </Dialog>
  );
};
